module.exports = {
      id: "menu_three_item-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#menu_three_item-usage",
      toString: function () {
        return this.url;
      }
    }